import type { DirectiveBinding } from 'vue';
import { getItem, setItem } from '../utils/localStorage';
import { storageKey, updateStarIcon } from '../utils/star';
import { mqMedium, toggle } from '../utils/utils';

const animateStar = (el: HTMLElement) => {
  if (mqMedium.matches) {
    const myAlbumIcon = document.getElementById('my-album-icon');

    if (myAlbumIcon) {
      const {
        left: iconLeft,
        top: iconTop,
        width: iconWidth,
        height: iconHeight,
      } = myAlbumIcon.getBoundingClientRect();

      const {
        left: starLeft,
        top: starTop,
        width: starWidth,
        height: starHeight,
      } = el.getBoundingClientRect();
      const iconCenterX = iconLeft + iconWidth / 2;
      const starCenterX = starLeft + starWidth / 2;
      const iconCenterY = iconTop + iconHeight / 2;
      const starCenterY = starTop + starHeight / 2;

      const deltaX = iconCenterX - starCenterX;
      const deltaY = starCenterY - iconCenterY;

      const removeTransition = (event: Event) => {
        if ((event as TransitionEvent).propertyName === 'transform') {
          el.style.setProperty('transition', 'none');
          el.style.setProperty('opacity', '0');
          setTimeout(() => {
            el.classList.remove('animation-star');

            setTimeout(() => {
              el.style.setProperty('transition', null);
              el.style.setProperty('opacity', null);
            }, 300);
          }, 300);
          el.removeEventListener('transitionend', removeTransition);
        }
      };

      el.addEventListener('transitionend', removeTransition);

      el.style.setProperty('--x', `${Math.ceil(deltaX)}px`);
      el.style.setProperty('--y', `-${Math.ceil(deltaY)}px`);
      el.classList.add('animation-star');
    }
  }
};

const updateState = (el: HTMLElement, id: number, animate = false) => {
  const starredObjectsString = getItem(storageKey);
  if (starredObjectsString) {
    const starredObjects: any[] = JSON.parse(starredObjectsString);

    if (starredObjects.includes(id)) {
      el.setAttribute('aria-pressed', 'true');
      if (animate) {
        animateStar(el);
      }
    } else {
      el.setAttribute('aria-pressed', 'false');
    }
  }
};

const starObject = (id: number): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (id) {
      const starredObjectsString = getItem(storageKey);

      if (starredObjectsString) {
        const starredObjects = JSON.parse(starredObjectsString);
        const newStarredObjects = toggle(starredObjects, id);
        setItem(storageKey, JSON.stringify(newStarredObjects));

        if ('gtag' in window) {
          if (newStarredObjects.includes(id)) {
            window.gtag('event', 'star_object', {
              event_label: id,
            });
          }
        }
      } else {
        setItem(storageKey, JSON.stringify([id]));

        if ('gtag' in window) {
          window.gtag('event', 'star_object', {
            event_label: id,
          });
        }
      }
      updateStarIcon();
      resolve();
    } else {
      reject();
    }
  });
};

const star = {
  beforeMount(el: Element, binding: DirectiveBinding) {
    el.addEventListener('click', () => {
      starObject(binding.value).then(() => {
        const animate = !el.classList.contains('button-sm');
        updateState(el as HTMLElement, binding.value, animate);
      });
    });
    updateState(el as HTMLElement, binding.value);
  },
};

export default star;
